<template>
  <div>
    <div v-if="address && top != 1"  class="mb-3 d-flex flex-row align-items-center">
      <div class="address-box-icon token-box-icon">
        <img src="../../images/token/eth.png"/>
      </div>
      <div class="ml-3">
        <div class="address-box-left-title pt-2">Token Details</div>
        <div class="address-box-left-text pt-2">
          <div class="address-box-copy">{{queryAddress}}<Copy :data="queryAddress"/></div>
        </div>
      </div>
    </div>
    <div v-show="page=='showTop'" class="container-top">
      <div class="container-title">
        <span>MRC20 Transfers</span>
        <span>Total {{totalTx}} txs (show 10,000 latest records)</span>
      </div>

      <div class="container-selectPage">
        <div class="change-page">
          <span>Show</span>
          <div @click.stop="showRecordPage=!showRecordPage" class="change-page-num">
            <span>{{nowRecordPage}}</span>
            <img src="../../images/transtion/arrow-bottom.png"/>
            <div v-show="showRecordPage" class="change-page-num-click">
              <span v-for="(item,index) in recordPage" :key="index"  @click.stop="actionSelectPage(item)">{{item.num}}</span>
            </div>
          </div>
          <span>Records</span>
        </div>
        <pagination-sp :config="cfg_pagination" @reloadList="getList()" class="py-3"/>
      </div>

    </div>
    <div class="bg-card mt-4">
      <div  class="token-in p-3">
        <div v-for="(item,index) in data_onshow" class="token-in-content">
          <div v-if="data_onshow && item.image" class="token-in-img-have">
            <img :src='item.image'/>
          </div>
          <div v-else class="token-in-img">
            <img src='../../images/token/nft-token-black.png'/>
          </div>
          <div class="token-in-text">
            TOKEN: <router-link style="font-size: 12px" :to="`/token/${item.contract}`"><span>{{item.name ? `${item.name}(${item.symbol})` : getSortAddress(item.contract)}}</span></router-link>
          </div>
          <div class="token-in-text">
            Token ID: <span>{{item.tokenId}}</span>
          </div>
          <div class="token-in-text">Owner: <router-link :to="`/address/${item.owner}`"><span style="font-size: 12px">{{getSortAddress(item.owner)}}</span></router-link></div>
          <!--                <div class="token-in-text">Last Traded: {{item.traded}}</div>-->
        </div>
        <div class="token-in-content token-in-item"></div>
        <div class="token-in-content token-in-item"></div>
        <div class="token-in-content token-in-item"></div>
        <div class="token-in-content token-in-item"></div>
      </div>
    </div>
  </div>
</template>

<script>
import paginationSp from '@/views/_comp/pagination_sp.vue'
import Copy from "@/views/_frame/copy";
import {getSortAddress} from '@/util/index'
import Decimal from "decimal.js";
export default {
  name: "TokenNft",
  props: [
    'cfg',
    'page',
    'top',
  ],
  components:{paginationSp,Copy},
  data() {
    return {
      address:'',
      tokenList:[],
      showRecordPage:false,//显示数据tab
      nowRecordPage:25,//当前显示数据
      recordPage:[
        {num:25},
        {num:50},
        {num:75},
        {num:100}
      ],//一页多少数据
      showImg:0,
      cfg_pagination: {
        'page_size': 25, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 0, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
      data_onshow: [{}],
      totalTx:0,
    }
  },
  methods :{
    getSortAddress(val){
      return getSortAddress(val)
    },
    //选择当前一页多少数据
    actionSelectPage(item) {
      let v = this
      v.nowRecordPage=item.num
      v.cfg_pagination.page_size=item.num
      v.showRecordPage=false
      // console.log(v.showRecordPage)
      v.initData()
    },
    initData(){
      let v = this

      // if(!v.data)return

      v.cfg_pagination.page_current = 1

      if(v.cfg){
        v.cfg_pagination.page_size = v.cfg.page_size
        v.cfg_pagination.page_current = v.cfg.page_current
      }

      // 过滤数据
      v.getList()
    },

    async getList(){
      let v = this
      // 过滤条目
      let start = v.cfg_pagination.page_current
      let end = v.cfg_pagination.page_size

      if(v.queryAddress){
        v.address = v.queryAddress
      }


      let params = {
        page: start,
        size: end,
        contract: v.address,
      }

      let result = await v.api('internalNftInfo', params, {
        vue: v,
        key_data: 'data',
      })
      if (result.code==200) {
        v.data_onshow = result.data.list
        v.totalTx = result.data.total
      }
      // console.log(v.data_onshow)

      // 计算页码
      if(v.totalTx < 10000){
        v.cfg_pagination.count_pages = Math.ceil(v.totalTx/v.cfg_pagination.page_size)
      }else{
        v.cfg_pagination.count_pages = Math.ceil(10000/v.cfg_pagination.page_size)
      }


    },
  },
  created() {
    // console.log('addressT',this.$route.params.number,this.addressT,this.contractT)
    if(this.address){
      this.queryAddress = this.address
    }else{
      this.queryAddress = this.$route.params.number
    }
  },
  mounted() {
    this.initData()
  },

}
</script>

<style scoped lang="less">

.token-in {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: space-between;
  padding-left: 0;
}


.token-in-content {
  border: 1px solid #e7eaf3;
  padding: 0.75rem;
  position: relative;
  width: 18%;
  min-width: 200px;
  max-width: 300px;
  margin-top: 10px;
  // padding: 5px 5px 10px 5px;
  //background: #323538;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.5s;
  border-radius: 4px;
  overflow: hidden;
  &:nth-child(1) {
    margin-top: 0;
  }
  &:nth-child(2) {
    margin-top: 0;
  }
  &:nth-child(3) {
    margin-top: 0;
  }
  &:nth-child(4) {
    margin-top: 0;
  }
  &:nth-child(5) {
    margin-top: 0;
  }
}


.token-in-img {
  height: 180px;
  //max-width: 180px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  background-color: rgba(119,131,143,.1)!important;
  margin-bottom: 5px;
  img {
    width: 64px;
  }
}

.token-in-img-have {
  height: 180px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: auto;
    height: auto;
    max-width: 60%;
    max-height: 60%;
    margin-left: auto;
    margin-right: auto;
  }
}

.token-in-item {
  background: none;
  box-shadow: none;
  height: 0;
  pointer-events: none;
  border: none;
  margin: 0;
  padding: 0;
}

.token-in-text {
  width: 100%;
  text-align: left;
  font-size: 12px;
  padding-top: 5px;
  span {
    color: #E44E3A;
  }
}

</style>
